import { Box, Button } from '@amzn/awsui-components-core';
import {
  ContentAccessUser,
  ContentHistory,
  ContentWorkflow,
  Epic,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../../common/constants';
import '../../../resources/styles/scss/components/common/EpicEditor.css';
import EpicCreatorForm from './EpicCreatorForm';
import EpicsList from './EpicsList';

interface Props {
  epics: Epic[];
  isEditable: boolean;
  onEpicsChanged: (epics: any[]) => void;
  contentId: string;
  workflowId: number;
  showSectionalComments?: boolean;
  workflow?: ContentWorkflow;
  workflowHistory?: ContentHistory[];
  coAuthors?: ContentAccessUser[];
}

interface State {
  numberOfEpicForms: number;
}

export default class EpicEditor extends React.Component<Props, State> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = {
      numberOfEpicForms: 0,
    };
  }

  public render() {
    const {
      epics,
      isEditable,
      contentId,
      showSectionalComments,
      workflow,
      workflowId,
      coAuthors,
      workflowHistory,
    } = this.props;
    const { numberOfEpicForms } = this.state;

    const epicCreatorForms = [];
    if (isEditable) {
      for (let i = 0; i < numberOfEpicForms; i++) {
        epicCreatorForms.push(
          <div key={i} className="epic-creator-form">
            <EpicCreatorForm epics={epics} confirmAddEpic={this.onEpicConfirmed} />
          </div>,
        );
      }
    }

    const addEpicButton = isEditable ? (
      <Box margin={{ top: 'l' }}>
        <Button iconName="add-plus" onClick={this.handleAddEpic}>
          {constants.ADD_EPIC_BUTTON}
        </Button>
      </Box>
    ) : null;

    return (
      <div>
        <div className="epics-list">
          <EpicsList
            isEditable={isEditable}
            onUpdated={this.onEpicsChanged}
            epics={epics}
            contentId={contentId}
            workflowId={workflowId}
            showSectionalComments={showSectionalComments}
            workflow={workflow}
            workflowHistory={workflowHistory}
            coAuthors={coAuthors}
          />
        </div>
        {epicCreatorForms}
        {addEpicButton}
      </div>
    );
  }

  private handleAddEpic = () => {
    const { numberOfEpicForms } = this.state;
    this.setState({
      numberOfEpicForms: numberOfEpicForms + 1,
    });
  };

  private onEpicsChanged = (epics: Epic[]) => {
    const { onEpicsChanged } = this.props;
    if (onEpicsChanged) {
      onEpicsChanged(epics);
    }
  };

  private onEpicConfirmed = (epic: Epic) => {
    this.onEpicsChanged([...this.props.epics, epic]);
  };
}
